var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PhIT 1.4 V1.1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1881,
    y: -6760,
    width: 23424,
    height: 32276.7,
    rx: 120,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597880968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22424,
    height: 3918,
    transform: "translate(-1381 -1504)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597880965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 29523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1940,
    height: 2878,
    transform: "translate(-881 -714)",
    fill: "#686767"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 29511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 29510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 29509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 29508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 29500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1220,
    height: 1871,
    transform: "translate(-411 -219)",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597881031"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -374,
    y: -35,
    width: 1146,
    height: 1576,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -374,
    y: -35,
    width: 1146,
    height: 1576,
    stroke: "#E6E6E6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 29532"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_6349_1610",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-339 0H737V60H-339V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-339 0H737V60H-339V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 59.75H-339V60.25H737V59.75Z",
    fill: "#686767",
    mask: "url(#path-3-inside-1_6349_1610)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597881056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597881055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1597881009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0C8.81733 0 5.76511 1.26433 3.51467 3.51467C1.26422 5.76511 0 8.81733 0 12C0 15.1827 1.26433 18.2349 3.51467 20.4853C5.76511 22.7358 8.81733 24 12 24C15.1827 24 18.2349 22.7357 20.4853 20.4853C22.7358 18.2349 24 15.1827 24 12C24 9.89358 23.4455 7.82422 22.3923 6C21.339 4.17578 19.8243 2.66089 18 1.60778C16.1758 0.554556 14.1065 4.442e-05 12 4.442e-05L12 0ZM13.6 18.1333C13.6 18.705 13.295 19.2332 12.8 19.519C12.305 19.8048 11.695 19.8048 11.2 19.519C10.705 19.2332 10.4 18.7049 10.4 18.1333V11.2C10.4 10.6284 10.705 10.1002 11.2 9.81433C11.695 9.52858 12.305 9.52858 12.8 9.81433C13.295 10.1002 13.6 10.6284 13.6 11.2V18.1333ZM12 7.46667C11.5757 7.46667 11.1687 7.29809 10.8687 6.998C10.5686 6.698 10.4 6.29098 10.4 5.86667C10.4 5.44236 10.5686 5.03533 10.8687 4.73533C11.1687 4.43524 11.5757 4.26667 12 4.26667C12.4243 4.26667 12.8313 4.43524 13.1313 4.73533C13.4314 5.03533 13.6 5.44236 13.6 5.86667C13.6 6.29098 13.4314 6.698 13.1313 6.998C12.8313 7.29809 12.4243 7.46667 12 7.46667Z",
    fill: "#076EB2"
  })))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.5f24737c9a665c8af03153529db3cdce.svg";
export { ForwardRef as ReactComponent };